import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditService, HttpService, NotificationService } from '../../../tms-shared';
import { Role, RoleDetails, RoleMenuItem, UpdateRoleMenuItem } from '../models';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends BaseEditService<Role, RoleDetails> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('Role', $localize`Role`, httpService, notificationService);
  }

  getRoleMenuItems(roleId: string): Observable<RoleMenuItem[]> {
    return this.httpService.get<RoleMenuItem[]>(`${this.apiUrl}/GetRoleMenuItems/${roleId}`);
  }

  updateRoleMenuItems(roleId: string, menuItems: UpdateRoleMenuItem[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateRoleMenuItems`, { roleId, menuItems });
  }
}
